/** Per-page primary Text Us label and default Ref code. A `ref` in the URL always wins. */
export const CAMPAIGN_PAGES: Record<string, { label: string; ref: string }> = {
  "/party-bus-atlanta": { label: "Plan My Night", ref: "WEB-NIGHT" },
  "/sprinter-limo-atlanta": { label: "Plan My Night", ref: "WEB-NIGHT" },
  "/uga-game-day-transportation": { label: "Check Game-Day Availability", ref: "WEB-GAME" },
  "/georgia-vs-florida-game-transportation": { label: "Check Oct 31", ref: "WEB-GATOR" },
  "/corporate-transportation-atlanta": { label: "Plan Executive Transportation", ref: "WEB-CORP" },
  "/corporate-holiday-party-transportation-atlanta": { label: "Check December", ref: "WEB-HOLIDAY" },
  "/thanksgiving-transportation-atlanta": { label: "Check Thanksgiving Dates", ref: "WEB-THANKS" },
  "/fbo-transportation-atlanta": { label: "Arrange FBO Pickup", ref: "WEB-JET" },
  "/private-jet-car-service-atlanta": { label: "Arrange FBO Pickup", ref: "WEB-JET" },
  "/atlanta-airport-car-service": { label: "Check Airport Ride", ref: "WEB-AIRPORT" },
  "/our-standard": { label: "Check My Date", ref: "WEB-VALUE" },
  "/our-story": { label: "Check My Date", ref: "WEB-FAMILIA" },
  "/winery-tour-transportation-atlanta": { label: "Plan My Wine Day", ref: "WEB-WINE" },
};

export function normalizePath(p: string) {
  return p.replace(/\/+$/, "") || "/";
}

export function campaignPage(path: string) {
  return CAMPAIGN_PAGES[normalizePath(path)];
}

/** Appends the required "Ref: <code>" line (replacing any existing Ref line). */
export function withRef(body: string, ref?: string) {
  const clean = body.replace(/\n?Ref: .*$/, "");
  return ref ? `${clean}\nRef: ${ref}` : clean;
}
